import { useUserState } from "portal-ui-remote/UserStateContext";
import React from "react";
import { Route, RouteProps } from "react-router-dom";

import PermissionsErrorDisplay from "components/PermissionsErrorDisplay";

interface AuthorizedRouteProps extends RouteProps {
  permission: string;
}

const AuthorizedRoute = ({
  permission,
  ...otherProps
}: AuthorizedRouteProps) => {
  const { userState } = useUserState();
  if (userState && !userState?.userPermissions.includes(permission)) {
    return <PermissionsErrorDisplay />;
  }

  return <Route {...otherProps} />;
};

export default AuthorizedRoute;
